import { PAGE_TYPE } from "./constants";
import { pickComponentHelper } from "@quintype/framework/server/pick-component-helper";

const { pickComponent, getChunkName } = pickComponentHelper(
  {
    [PAGE_TYPE.HOME_PAGE]: { chunk: "list", component: "HomePage" },
    [PAGE_TYPE.SECTION_PAGE]: { chunk: "list", component: "SectionPage" },
    [PAGE_TYPE.TAG_PAGE]: { chunk: "list", component: "TagPage" },
    [PAGE_TYPE.SEARCH_PAGE]: { chunk: "list", component: "SearchPage" },
    [PAGE_TYPE.FORM_PAGE]: { chunk: "list", component: "FormPage" },
    [PAGE_TYPE.STORY_PAGE]: { chunk: "story", component: "StoryPage" },
    [PAGE_TYPE.AUTHOR_PAGE]: { chunk: "list", component: "AuthorPage" },
    [PAGE_TYPE.CATALOG_PAGE]: { chunk: "list", component: "CatalogPage" },
    [PAGE_TYPE.STORY_PREVIEW]: { chunk: "story", component: "StoryPagePreview" },
    [PAGE_TYPE.STORY_PUBLIC_PREVIEW_PAGE]: { chunk: "story", component: "StoryPage" },
    [PAGE_TYPE.HOME_PREVIEW]: { chunk: "list", component: "HomePagePreview" },
    [PAGE_TYPE.TULO_LOGIN]: { chunk: "list", component: "TuloLogin" },
    [PAGE_TYPE.NATIVE_AD_CARD]: { chunk: "list", component: "NativeAdStory" },
    [PAGE_TYPE.BANNER_PAGE]: { chunk: "list", component: "BannerPage" },
    [PAGE_TYPE.URHEILU_IPPE_PAGE]: { chunk: "list", component: "UrheiluIppePage" },
    [PAGE_TYPE.KIEKKO_IPPE_PAGE]: { chunk: "list", component: "UrheiluIppePage" },
    [PAGE_TYPE.PESIS_IPPE_PAGE]: { chunk: "list", component: "UrheiluIppePage" },
    [PAGE_TYPE.SALIBANDY_IPPE_PAGE]: { chunk: "list", component: "UrheiluIppePage" },
    [PAGE_TYPE.FUTIS_IPPE_PAGE]: { chunk: "list", component: "UrheiluIppePage" },
    [PAGE_TYPE.TULOSPALVELU_VAASA_PAGE]: { chunk: "list", component: "UrheiluIppePage" },
    [PAGE_TYPE.PESAPALLOTULOKSET_VAASALEHTI_PAGE]: { chunk: "list", component: "UrheiluIppePage" },
    [PAGE_TYPE.JAAKIEKKOTULOKSET_VAASALEHTI_PAGE]: { chunk: "list", component: "UrheiluIppePage" },
    [PAGE_TYPE.JALKAPALLOTULOKSET_VAASALEHTI_PAGE]: { chunk: "list", component: "UrheiluIppePage" },
    [PAGE_TYPE.SALIBANDYTULOKSET_VAASALEHTI_PAGE]: { chunk: "list", component: "UrheiluIppePage" },
    [PAGE_TYPE.JUTTUSARJAT_VAASALEHTI_PAGE]: { chunk: "list", component: "VaasaJuttusarjatPage" },
    [PAGE_TYPE.ELECTION_PAGE]: { chunk: "list", component: "ElectionPage" },
    [PAGE_TYPE.ELECTIONRESULTS_PAGE]: { chunk: "list", component: "ElectionResultsPage" },
    [PAGE_TYPE.VAASA_HOME_PAGE]: { chunk: "list", component: "VaasaHomePage" },
    [PAGE_TYPE.EPARI_HOME_PAGE]: { chunk: "list", component: "EpariHomePage" },
    [PAGE_TYPE.GAME_PAGE]: { chunk: "list", component: "GamePage" },
    [PAGE_TYPE.STUDIO_PAGE]: { chunk: "list", component: "StudioPage" },
    [PAGE_TYPE.PROFILE_PAGE]: { chunk: "list", component: "ProfilePage" },
    [PAGE_TYPE.ACTIVE_SESSIONS]: { chunk: "list", component: "TuloActiveSessions" },
    default: { chunk: "list", component: "NotFoundPage" }
  },
  {
    list: () => import(/* webpackChunkName: "list" */ "./component-bundles/list.js"),
    story: () => import(/* webpackChunkName: "story" */ "./component-bundles/story.js")
  }
);

export { pickComponent, getChunkName };
